import React from "react";
import VendorItemGenericSkeleton from "./VendorItemGenericSkeleton";

function VendorItemDetailSkeleton() {
  return (
    <>
      <VendorItemGenericSkeleton />
    </>
  );
}

export default VendorItemDetailSkeleton;
